// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"42":"52e97592","566":"dd503dc2","591":"1c931e68","640":"a8796901","647":"471d34fa","874":"00fe9383","884":"8f42f909","894":"affdbafa"}[chunkId] + ".js";
};